import { useTranslation } from "react-i18next";
import { SUPPORTED, type Language } from "../i18n";

/**
 * Two-segment switch matching the ThemeToggle's look: pill, mono caps,
 * active segment fills with the surface colour. Lives next to the
 * theme toggle in the Nav so both controls share the same visual
 * weight.
 */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current = (i18n.language?.slice(0, 2) || "en") as Language;
  return (
    <div
      role="radiogroup"
      aria-label={t("nav.languageLabel")}
      className="inline-flex rounded-md border border-stone-200 dark:border-stone-700 bg-stone-50 dark:bg-stone-900 p-0.5"
    >
      {SUPPORTED.map((lng) => {
        const active = current === lng;
        return (
          <button
            key={lng}
            role="radio"
            aria-checked={active}
            onClick={() => {
              void i18n.changeLanguage(lng);
            }}
            title={t(`language.${lng}`)}
            className={[
              "px-1.5 py-1 text-[10.5px] font-mono uppercase tracking-widest rounded transition-colors",
              active
                ? "bg-white dark:bg-stone-700 text-stone-900 dark:text-stone-100 shadow-sm"
                : "text-stone-500 dark:text-stone-400 hover:text-stone-700 dark:hover:text-stone-200",
            ].join(" ")}
          >
            {lng}
          </button>
        );
      })}
    </div>
  );
}
